const moment = require('moment-timezone');

// This is created as a central object for formatting date or time
// This also serves as a flexible object which currently uses moment but
// can be changed to other time formatting libraries with changing much of the
// the code.
const timedate = {
  // Initial moment object
  data: moment(),
  // Default Timezone Australia/Sydney
  timezone: 'Australia/Sydney',

  // Default date format, CHANGE this when needed
  timeFormat: 'HH:mm',

  // Default date format, CHANGE this when needed
  dateFormat: 'DD MMM YYYY',

  // Default date time format, CHANGE this when needed
  dateTimeFormat: 'DD MMM YYYY, HH:mm',

  // Default day month and time format, CHANGE this when needed
  dayMonthTimeFormat: 'DD MMM, HH:mm',

  // Default date format for input, CHANGE this when needed
  formDateFormat: 'dd MMM yyyy',

  // Default date and time format for input, CHANGE this when needed
  formDateTimeFormat: 'dd MMM yyyy, HH:mm',

  // Set time which creates a moment object
  set(timecontent) {
    this.data = moment(timecontent);
    return this;
  },
  // Set a custom moment object
  setMomentObject(momentObject) {
    this.data = momentObject;
    return this;
  },
  // Set time with UTC
  utc(timecontent) {
    this.data = moment.utc(timecontent).tz(this.timezone);
    return this;
  },
  // Set Timezone
  tz(timezone) {
    this.timezone = timezone;
    this.data.tz(this.timezone);
    return this;
  },
  // Convert time object to string with format as parameter
  format(formatString) {
    return this.data.format(formatString);
  },
  // Default format with just the date
  fDate() {
    return this.format(this.dateFormat);
  },
  // Default format with the date and time
  fDateTime() {
    return this.format(this.dateTimeFormat);
  },
  // Default format with the date and time
  fTime() {
    return this.format(this.timeFormat);
  },
  // Default format with the day month and time
  fDayMonthTime() {
    return this.format(this.dayMonthTimeFormat);
  },
};

module.exports = {
  timedate
};
